export default __webpack_public_path__ + "static/media/selectTeam5.72f2ba08.mp3";